var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.831,
    height: 108.33,
    viewBox: "0 0 109.831 108.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(-794.085 -1629.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M102.558,96.4H16.272A10.272,10.272,0,0,1,6,86.123V16.272A10.272,10.272,0,0,1,16.272,6h86.286A10.272,10.272,0,0,1,112.83,16.272V86.123A10.272,10.272,0,0,1,102.558,96.4ZM16.272,10.109a6.163,6.163,0,0,0-6.163,6.163V86.123a6.163,6.163,0,0,0,6.163,6.163h86.286a6.163,6.163,0,0,0,6.163-6.163V16.272a6.163,6.163,0,0,0-6.163-6.163Z",
    transform: "translate(789.585 1624.749)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M23,49H59.98V65.435H23Z",
    transform: "translate(807.51 1670.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M76.579,60.109H19.054a2.054,2.054,0,1,1,0-4.109H76.579a2.054,2.054,0,1,1,0,4.109Z",
    transform: "translate(801.184 1677.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M7,41H109.722v8.218a8.218,8.218,0,0,1-8.218,8.218H15.218A8.218,8.218,0,0,1,7,49.218Z",
    transform: "translate(790.639 1661.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M33.755,50.894a2.054,2.054,0,0,1-1.459-.616L16.806,34.87a2.157,2.157,0,0,1-.6-1.459,2.054,2.054,0,0,1,.616-1.459L32.214,16.626a2.056,2.056,0,0,1,2.9,2.917L21.1,33.411,35.131,47.443a2,2,0,0,1-1.376,3.451Z",
    transform: "translate(798.351 1635.324)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M39.715,50.894a2.065,2.065,0,0,1-1.438-3.513L52.288,33.349,38.338,19.544a2.056,2.056,0,1,1,2.9-2.917L56.7,31.952a2.054,2.054,0,0,1,0,2.917L41.214,50.34a2.054,2.054,0,0,1-1.5.555Z",
    transform: "translate(824.988 1635.324)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M28.364,62.949a2.321,2.321,0,0,1-.74-.123,2.054,2.054,0,0,1-1.171-2.671L44.615,13.478a2.054,2.054,0,1,1,3.821,1.479l-18.161,46.7a2.054,2.054,0,0,1-1.911,1.294Z",
    transform: "translate(811 1631.098)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.e6625857617b04c0022942a5a48f27a9.svg";
export { ForwardRef as ReactComponent };